import resolveConfig from 'tailwindcss/resolveConfig';

import { content, theme } from '../../tailwind.config.js';

const fullConfig = resolveConfig({ content, theme } as any);

// Brand
export const brandYellow1 = fullConfig?.theme?.colors['brand-yellow'][1];
export const brandYellow3 = fullConfig?.theme?.colors['brand-yellow'][3];
export const brandGrey2 = fullConfig?.theme?.colors['brand-grey'][2];
export const brandGrey1 = fullConfig?.theme?.colors['brand-grey'][1];

// Neutral grey
export const neutralGrey300 = fullConfig?.theme?.colors['neutral-grey'][300];
export const neutralGrey400 = fullConfig?.theme?.colors['neutral-grey'][400];

export const TAG_COLORS: Record<string, string> = {
  grey: 'border-brand-grey-2',
  green: 'border-brand-green-4',
  red: 'border-brand-red-2',
  blue: 'border-brand-blue-5',
  yellow: 'border-brand-yellow-1',
  orange: 'border-brand-yellow-2',
  default: 'border-brand-grey-2',
};

export function getTagBorderColor(value?: string): string {
  if (!value) return TAG_COLORS['default'];
  const color = value.toLowerCase().split(' - ')[0]?.trim();
  return TAG_COLORS[color] ?? TAG_COLORS['default'];
}
